<template>
  <div id="app">
    <template>
      <router-view />
    </template>
  </div>
</template>
<script>
  export default {
    data(){
      return {
        isInit:false
      };
    },
    watch: {
      $route: function (to) {
        if (to.path && !this.isInit) {
          this.initLanguage();
          this.isInit = true;
        }
      },
    },
    created(){
    },
    mounted() {
      // let _this = this;
      // window.addEventListener(
      //   'onorientationchange' in window ? 'orientationchange' : 'resize',
      //   function () {
      //     if (window.orientation === 90 || window.orientation === -90) {
      //       _this.$toast('app.tipMsg');
      //     }
      //   },
      //   false
      // );
      // if (window.orientation === 90 || window.orientation === -90) {
      //   _this.$toast('app.tipMsg');
      // }
    },
    methods: {
      initLanguage () {
        const queryLang = this.$route.query && this.$route.query.lang;
        const langList = ['zh', 'en'];

        // 先设置默认语言，再进行国际化
        let lang = queryLang || localStorage.getItem('lang');

        if (!lang) {
          lang = navigator.language || navigator.userLanguage || 'zh';
          lang = lang.substring(0, 2);
          if (langList.indexOf(lang) === -1) {
            lang = 'en';
          }
        }

        if (langList.indexOf(lang) === -1) {
          lang = 'en';
        }
        localStorage.setItem('lang', lang);
        this.$i18n.locale = lang;
      }
    }
  };
</script>
<style>
@import '//at.alicdn.com/t/font_2243115_s37n9tetevs.css';
[class^="kf-"], [class^=" kf-icon-"] {
  font-family: "iconfont", serif !important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}
#app {
  width: 100%;
  height: 100%;
}
</style>
